import type { PacketSourceResolved } from "../lib/api";
import { OutlookEmailView } from "./sources/OutlookEmailView";
import { CalendarEventView } from "./sources/CalendarEventView";
import { GmailEmailView } from "./sources/GmailEmailView";
import { MessageView } from "./sources/MessageView";
import { GenericPacketView } from "./sources/GenericPacketView";

/** Picks a per-source-kind renderer for the universal packet
 *  viewer. Adding a new source kind = adding one branch here. */

export function PacketDetailRouter({ resolved }: { resolved: PacketSourceResolved }) {
  const kind = resolved.render.kind;
  switch (kind) {
    case "outlook-email":
      return <OutlookEmailView resolved={resolved} />;
    case "gmail-email":
      return <GmailEmailView resolved={resolved} />;
    case "outlook-calendar":
    case "calendar-event":
      return <CalendarEventView resolved={resolved} />;
    case "teams-message":
    case "whatsapp-message":
    case "sms-message":
      return <MessageView resolved={resolved} />;
    case "outlook-task":
    case "obsidian-note":
    case "voice-transcript":
    case "rss-item":
    case "linkedin":
    case "manual-note":
    case "generic":
    default:
      return <GenericPacketView resolved={resolved} />;
  }
}
